import React, { useEffect } from 'react';
import ContentLoader from 'react-content-loader';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { fetchSinglepost } from '../features/post/SinglePost';
import { fetchposts, SavedSinglepost } from '../features/posts/postSlice';
import { fetchPostWithTags } from '../features/tag/tagSlice';

const BlogDetails = () => {

  const {postId}=useParams();
const {postDetail}=useSelector(state=>state.postDetails);
const {posts}=useSelector(state=>state?.tagPosts);

const dispatch =useDispatch()
  useEffect(() => {
    dispatch(fetchSinglepost(postId)).then(res=>{

      dispatch(fetchPostWithTags(res?.payload?.tags))
      
    })
  }, [postId])
  
  
  const {title,likes,isLiked,isSaved,description,image,createdAt,tags,id,isLoading}=postDetail;



  return (
  
  <>
 
 <div>
  <div className="container mt-8">
    <Link to="/" className="inline-block text-gray-600 home-btn" id="lws-goHome"><i className="mr-2 fa-solid fa-house" />Go Home</Link>
  </div>
 {isLoading ?    <ContentLoader viewBox="0 0 380 70">
    {/* Only SVG shapes */}    
    <rect x="0" y="0" rx="5" ry="5" width="70" height="70" />
    <rect x="80" y="17" rx="4" ry="4" width="300" height="13" />
    <rect x="80" y="40" rx="3" ry="3" width="250" height="10" />
  </ContentLoader> : <section className="post-page-container">
    {/* detailed post  */}
    <main className="post">
      <img src={image} alt="githum" className="w-full rounded-md" id="lws-megaThumb" />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
   {title}
        </h1>
        <div className="tags" id="lws-singleTags">
         {tags?.map(tag=>(<span key={tag}>#{tag},</span>))}  
        </div>
        <div className="btn-group">
          {/* handle like on button click */}
          <button  className={`like-btn`}   id="lws-singleLinks"   onClick={()=>{
            dispatch(SavedSinglepost({...postDetail,updateItem:"isLiked"})).then(res=>{
           toast.success('Like Successfully')

              dispatch(fetchSinglepost(postId))
  dispatch(fetchposts())

            })
          }}>
            <i className="fa-regular fa-thumbs-up" /> {likes}
          </button>
          {/* handle save on button click */}
          {/* use ".active" class and "Saved" text  if a post is saved, other wise "Save" */}
          <button className={`save-btn ${isSaved ? 'active':""}`} id="lws-singleSavedBtn" onClick={()=>{
            dispatch(SavedSinglepost({...postDetail,updateItem:"isSaved"})).then(res=>{
              postDetail?.isSaved.toString()=="true" ? 
              toast.error('Remove from Saved') :  toast.success('Saved successfully')
              dispatch(fetchSinglepost(postId))
  dispatch(fetchposts())

            })
          }}>
            <i className="fa-regular fa-bookmark" /> Saved
          </button>
        </div>
        <div className="mt-6">
          <p>
          {description}
          </p>
        </div>
      </div>
    </main>
    {/* detailed post ends */}
    {/* related posts */}
    <aside>
      <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">Related Posts</h4>
      <div className="space-y-4 related-post-container">
        {/* related post  */}
     {posts?.filter(p=>p?.id != postId).map(post=>(
      <div className="card" onClick={()=>{
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }} >
          <Link to={`/blog/${post?.id}`}>
            <img src={post?.image} className="card-image" alt />
          </Link>
          <div className="p-4">
            <Link to={`/blog/${post?.id}`} className="text-lg post-title lws-RelatedPostTitle">
              {post?.title}
            </Link>
            <div className="mb-0 tags">
            {post?.tags?.map(tag=>(<span key={tag}>#{tag},</span>))}  
            </div>
            <p>{post?.createdAt}</p>
          </div>
        </div>

     ))   }



        </div>
        {/* related post ends */}
     
    </aside>
    {/* related posts ends */}
  </section>}
</div>

    </>
  )
}

export default BlogDetails